module.exports = __webpack_public_path__ + "img/W7019-thumb.bfa5b0f6.jpg";